export default __webpack_public_path__ + "static/media/closet5-after1-1024w.62f8bd78.png";